import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_edit",
  "use": "icon_edit-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 14 14\" id=\"icon_edit\"><path d=\"M.658 13.568l.003.003a.71.71 0 00.734.171l4.057-1.376 7.784-7.784A2.538 2.538 0 109.646.993L1.864 8.778.487 12.834a.71.71 0 00.171.734zM10.293 1.64a1.624 1.624 0 012.296 2.296l-1.023 1.023L9.27 2.663l1.023-1.023zM2.66 9.273L8.623 3.31l2.296 2.296-5.963 5.963-3.475 1.179L2.66 9.273z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol